var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "28px",
    viewBox: "0 0 22 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-pdf-file-6700469") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-3",
    transform: "translate(-408, -539)",
    fill: "#00467D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(408, 539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,25 C0,26.649984 1.350016,28 3,28 L9,28 C9.550016,28 10,27.550016 10,27 C10,26.449984 9.550016,26 9,26 L3,26 C2.449984,26 2,25.550016 2,25 L2,3 C2,2.449984 2.449984,2 3,2 L12,2 L12,7 C12,8.649984 13.350016,10 15,10 L20,10 L20,17 C20,17.550016 20.449984,18 21,18 C21.550016,18 22,17.550016 22,17 L22,8.83008 C22,8.03008 21.69,7.27008 21.12,6.71008 L15.28992,0.88 C14.72992,0.310016 13.96992,0 13.16992,0 L3,0 C1.350016,0 0,1.350016 0,3 L0,25 Z M19.59008,8 L15,8 C14.449984,8 14,7.550016 14,7 L14,2.40992 L19.59008,8 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0000872,18 C16.4602361,18 16.0103442,18.4399984 16.000363,18.9799965 L16.000363,19.3199953 C15.9803685,20.1599923 15.8004181,21.3199882 15.1305869,22.51 C14.350802,23.8899951 13.281113,24.7000082 12.5113094,25.1299906 C12.0314417,25.3999897 11.8615046,26 12.1214009,26.4800018 C12.3812972,26.9600001 12.991177,27.1399995 13.4710447,26.8800004 C14.2208538,26.4800018 15.4504987,26 17,26 C18.5494839,26 19.7692114,26.4800018 20.5289379,26.8800004 C20.6788965,26.9600001 20.8388524,27 20.9988243,27 C21.3487437,27 21.6986312,26.8100007 21.8785816,26.4800018 C22.1385099,26 21.9685568,25.4000057 21.4886732,25.1299906 C20.7189015,24.6999762 19.6491805,23.899979 18.8693956,22.51 C18.1995644,21.3199882 18.019646,20.1599923 17.9996195,19.3199953 L17.9996195,18.9799965 C17.9896223,18.4399984 17.5397464,18 16.9998953,18 L17.0000872,18 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconBlue);
export default __webpack_public_path__ + "static/media/file-icon--blue.1e8cbcc0c7a67a351003c4d2eca979d4.svg";
export { ForwardRef as ReactComponent };